import script from "./validador-documentos.vue?vue&type=script&setup=true&lang=js"
export * from "./validador-documentos.vue?vue&type=script&setup=true&lang=js"

import "./validador-documentos.vue?vue&type=style&index=0&id=bbecb1a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbecb1a2"]])

export default __exports__